import { useQuery, UseQueryResult } from "react-query";
import { getDiagnostic } from "apps/project-iq/api";
import { IDiagnostic } from "apps/project-iq/models/IDiagnostic";

export const useWorkspaceDiagnostic = (
  diagnosticId: string,
): UseQueryResult<IDiagnostic> => {
  return useQuery<IDiagnostic, Error>({
    queryKey: ["workspace-diagnostic", diagnosticId],
    queryFn: () => getDiagnostic({ diagnosticId }),
    enabled: !!diagnosticId,
    refetchOnWindowFocus: false,
  });
};
